import { skipToken } from "@tanstack/react-query";
import { shopifyRouter } from "@v1/trpc/routes/shopify";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import sortBy from "lodash-es/sortBy";

export const useFetchVariantMetafieldsDefinitions = (config: {
  shouldSkip: boolean;
}) => {
  const projectId = useCurrentProjectId();

  const { data, isLoading } =
    shopifyRouter.getVariantMetafieldDefinitions.useQuery(
      projectId && !config.shouldSkip ? projectId : skipToken,
    );

  // Note (Noah, 2022-01-13, REPL-5986): Sort metafield definitions, there might
  // be a lot of them
  return {
    isLoading,
    variantMetafieldsDefinitions: data ? sortBy(data, "name") : undefined,
  };
};
